'use strict';

var dropdown = function($container){
	$container.each(function () {
		var $dropdown = $(this);
		$dropdown.on("click", function (e) {
			$dropdown.toggleClass("dropdown--open");
		});
	});
};